import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Location } from '@angular/common'

@Component({
  selector: 'cm-toolbar-back',
  templateUrl: './toolbar-back.component.html',
  styleUrls: ['./toolbar-back.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarBackComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  back() {
    this.location.back()
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-back/toolbar-back.component.ts